import style from "./ChapterBreadcrumbs.module.scss";

const ChapterBreadcrumbs = ({ children }) => {
  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <div className={`${style.breadcrumbs}`}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default ChapterBreadcrumbs;
